module.exports = __webpack_public_path__ + "img/comprovei_anim_loop2.0.76d2cbee.svg";